import React  from "react";
import {Button,Card,Form,Container,Row,Col} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import {useFichaSesion} from '../hooks/useFichaSesion';
import Select from 'react-select'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/es';

function EditarSesion(){
  
  const parametros = useParams();
  
  const { 
      usuariosTo,
      usuariosSicologas,
      usuariosOtros,
      editSesion,
      respuestaEditarSesion,
      sesionFicha,
      setSesionFicha,
      updateRespuestaEditarSesion      
      
  } = useFichaSesion(parametros.sesionId);

  let opcionesSelectorTO=[];
        let opcionesSelectorPsicologas=[];
        let opcionesSelectorOtros=[];

  usuariosTo?.map((elem)=>{
    opcionesSelectorTO.push(
          {
              value:elem.Usuario,
              label:elem.NombreSocial 
            }
      )
  });
  usuariosSicologas?.map((elem)=>{
      opcionesSelectorPsicologas.push(
            {
                value:elem.Usuario,
                label:elem.NombreSocial 
              }
        )
  });
  usuariosOtros?.map((elem)=>{
      opcionesSelectorOtros.push(
            {
                value:elem.Usuario,
                label:elem.NombreSocial 
              }
        )
  });

const editarSesion = async() => {
    const resp=await editSesion(sesionFicha);
    updateRespuestaEditarSesion()
      
};

  return (
    <>
      <Container fluid>
      <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Sesión</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                                 
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Nombre Social</label>
                        <Form.Control
                          value={sesionFicha?.NombreSocial}
                          placeholder=""
                          type="text"
                          disabled
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group>
                        <label>Rut</label>
                        <Form.Control
                          value={sesionFicha?.Rut}
                          placeholder=""
                          type="text"
                          disabled
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="6">
                    <label>Profesionales Psicóloga</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorPsicologas}
                        value={opcionesSelectorPsicologas?.filter(item => sesionFicha?.ProfesionalSicologa?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ (e,prop) => {
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setSesionFicha({...sesionFicha,['ProfesionalSicologa']:valorArreglo});
                        }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Profesionales Terapeuta Ocupacional</label>
                        <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorTO}
                        value={opcionesSelectorTO?.filter(item => sesionFicha?.ProfesionalTo?.includes(item.value))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={ (e,prop) => { 
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setSesionFicha({...sesionFicha,['ProfesionalTo']:valorArreglo});
                        }}
                       
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs="6">
                    <label>Profesionales Otros</label><br></br>
                    <Select
                        placeholder="Seleccione una o más opciones"
                        isMulti
                        options={opcionesSelectorOtros}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={opcionesSelectorOtros?.filter(item => sesionFicha?.ProfesionalOtro?.includes(item.value))}
                        onChange={ (e,prop) => { 
                          let valorArreglo=[];
                          for(var i=0;i<e.length;i++){
                            valorArreglo.push(e[i].value)
                          }
                          setSesionFicha({...sesionFicha,['ProfesionalOtro']:valorArreglo});
                           
                        }}
                        
                        />
                    </Col>
                    <Col xs="6">
                        <label>Fecha Sesión (Hora Santiago,Chile)</label>
                        <Datetime
                            value={moment(sesionFicha?.FechaSesion)}
                            utc={true}
                            onChange={(date) => {
                              const d = moment(date);
                              setSesionFicha({...sesionFicha,['FechaSesion']:d});
                            }}
                            
                        ></Datetime>
                         
                      
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                 
                    <label>Comentarios</label>
                    <Form.Control
                       
                        value={sesionFicha?.Comentario}
                        placeholder=""
                        type="textarea"
                        as="textarea"
                        maxLength={4000}
                        onChange={ (e,prop) => { 
                          let valor=e.target.value;
                          valor=valor.slice(0, 4000);
                          setSesionFicha({...sesionFicha,['Comentario']:valor});
                        }}
                        rows={12}>

                    </Form.Control>
                    <div style={{ textAlign: 'right', marginTop: 4, color: '#666' }}>
                        {sesionFicha?.Comentario?.length} / {4000}
                    </div>
                   
                    </Col>
                   
                </Row>
                 
                  <Button
                    className="btn-fill pull-right"
                    type="submit"
                    variant="info"
                    onClick={(e)=>{
                      e.preventDefault();
                      editarSesion();}}>
                    Guardar
                  </Button>
                  
                  <div className="clearfix"></div>
                  <br></br>
                  <MensajeAlerta mensajeTexto={respuestaEditarSesion.mensajeTexto} estado={respuestaEditarSesion.estado} />
                  
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
          
      </Row>
       
      </Container>
    </>
  );
  
}

export default EditarSesion;
